// @ts-nocheck
import { Dialog, Button } from '@workspace/design-system/src/components';
import { getPlanLabel } from '../constants';
interface PlanActionDialogProps {
  mode: 'apply' | 'extend';
  channelName: string;
  currentPlan?: string;
  onClose: () => void;
  onConfirm: () => void;
  onActionWithoutPayment: () => void;
}

/**
 * 요금제 적용/연장 액션 선택 다이얼로그
 * apply-plan-with-customer-dialog와 extend-plan-request-dialog를 통합한 공통 컴포넌트
 */
export function PlanActionDialog({
  mode,
  channelName,
  currentPlan,
  onClose,
  onConfirm,
  onActionWithoutPayment
}: PlanActionDialogProps) {
  const isApplyMode = mode === 'apply';
  
  const title = isApplyMode 
    ? '유료 요금제를 적용할까요?' 
    : `${getPlanLabel(currentPlan || '')} 요금제를 연장하시겠습니까?`;
  
  const description = isApplyMode
    ? `${channelName} 채널에 유료 요금제를 적용하려면 결제 요청을 먼저 진행해 주세요.`
    : `${channelName} 채널에 ${currentPlan} 요금제를 연장하려면 결제 요청을 먼저 진행해 주세요.`;
  
  const withoutPaymentText = isApplyMode ? '결제 없이 적용' : '결제 없이 연장';

  return (
    <Dialog>
      <Dialog.Content>
        <Dialog.Header title={title} type="question" showIcon />

        <Dialog.Body>
          <div className="flex flex-col gap-2">
            <p className="text-[14px] text-[#595959] leading-[20px] tracking-[-0.1px]">
              {description}
            </p>
          </div>
        </Dialog.Body>

        <Dialog.Footer>
          <div className="flex justify-between w-full">
            <button
              onClick={onActionWithoutPayment}
              className="flex-1 h-10 min-w-24 pr-6 rounded-xl flex justify-start items-center overflow-hidden cursor-pointer"
            >
              <div className="flex justify-center items-center gap-1">
                <div className="text-center justify-start text-[#d15445] text-base font-bold font-['Pretendard'] leading-5">
                  {withoutPaymentText}
                </div>
              </div>
            </button>
            <div className="flex gap-2">
              <Button
                type="button"
                onClick={onClose}
              >
                닫기
              </Button>
              <Button
                type="button"
                styleType="primary"
                onClick={onConfirm}
              >
                결제 요청
              </Button>
            </div>
          </div>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
}

